import styled from '@emotion/styled/macro';
import Icon from '@mdi/react';
import { IOrdinalProps, pieChartColors } from './shared.styles';

export const PieLegend = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;

    & > table {
        flex-grow: 1;
        max-width: 320px;
    }
`;

export const LegendField = styled.td`
    flex-grow: 1;
`;

export const LegendDot = styled(Icon)<IOrdinalProps>`
    fill: ${pieChartColors};
    height: 12px;
    width: 12px;
    margin: 0 8px;
`;

export const LegendItem = styled.tr<IOrdinalProps>`
    &:nth-of-type(odd) {
        padding-right: 12px;
    }
    &:first-of-type {
        padding-right: 0;
        margin-right: 2px; /* NB: force line wrap */
    }
    & ${LegendField}:nth-of-type(1) {
    }
    & ${LegendField}:nth-of-type(2),
    & ${LegendField}:nth-of-type(3) {
        text-align: right;
    }
`;
